const assessmentDecisions = [
    {
        "id": "1",
        "appNo": "A21080212",
        "appType": "initial",
        "customerNo": "0001",
        "customerName": "中農粉絲有限公司",
        "assessmentPlace": "台東廠",
        "decision": "approve",
        "inspectionDate": "2022-01-05T00:00:00.000Z",
        "suggestions": [
            {"suggestion": "建議事項1.............................."},
            {"suggestion": "建議事項2.............................."}
        ],
        "notices": [
            {"notice": "注意事項1..............................."},
            {"notice": "注意事項2..............................."},
            {"notice": "注意事項3..............................."}
        ],
        "inspectionContent":{
            "standard":"leezen",
            "inspectionItems":[
                {"productionLine":"line1", "products":["Natural Benefits 食安生技-椰子汁"]},
                {"productionLine":"line2", "products":["杏仁玄米餅","核桃酥"]}
            ],
            "inspectionScope":"評鑑產品之評鑑場所場區環境與衛生管理、製程與品質管制、原料查驗、相關檢驗報告與紀錄表單核對等，及前次所列查驗重點之執行狀況確認"
        },
        "inspectionResult":{
            "previousNcrs":[
                {
                    "appNo":"A20080111",
                    "type":"secondary",
                    "inspectionItem":"03-3",
                    "observationDesc":"碳酸鈣550g/包,未涵蓋使用範圍"
                },
                {
                    "appNo":"A20080111",
                    "type":"secondary",
                    "inspectionItem":"06-1",
                    "observationDesc":"評鑑產品之評鑑場所場區環境與衛生管理、製程與品質管制"
                }
            ],
            "productChangeInspectionKeyNote":"1.員工衛生新進食品從業人員應先經醫療機構健康檢查合格後，始得聘僱；雇主每年應主動辦理健康檢查至少一次。\n" +
                "2.員工教育訓練：新進食品從業人員應接受適當之教育訓練，使其執行能力符合生產、衛生及品質管理之要求；在職從業人員，應定期接受食品安全、衛生及品質管理之教育訓練，並作成紀錄。",
            "leezenRawMaterials":[
                {
                    "id":"1",
                    "type":"material",
                    "name":"豆蓉粉(新版)",
                    "storageCondition":"roomTemperature",
                    "composition":"水、非基因改造脫脂黃豆片、小麥、食鹽、轉化液糖(蔗糖、水)、調味劑(DL-蘋果酸)",
                    "domesticVendor":"穎昌食品有限公司(新和美)",
                    "importer":"",
                    "manufacturer":"穎昌食品有限公司(新和美)",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "addRatio":9,
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":1,
                    "validityAndSituation":"有效日期：2022/03/19(此批非里仁使用)",
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"2",
                    "type":"material",
                    "name":"美國加州杏仁果",
                    "storageCondition":"roomTemperature",
                    "composition":"樹薯澱粉、水(原料)",
                    "domesticVendor":"信成股份有限公司",
                    "importer":"信成股份有限公司",
                    "manufacturer":"TERRA NOVA TRADING INC.",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":2,
                    "validityAndSituation":"有效日期：2023/04/18",
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"3",
                    "name":"美國加州杏仁果",
                    "storageCondition":"refrigeration",
                    "composition":"植物油脂(菜籽油)、洋蔥、葡萄糖、抗氧化劑(維生素C、混合濃縮生育醇)",
                    "domesticVendor":"爾邦得有限公司",
                    "importer":"爾邦得有限公司",
                    "manufacturer":"TERRA NOVA TRADING INC.",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":3,
                    "validityAndSituation":"槽車運送日期2021/09/14(保存期限3個月)，平均約1個月左右進貨一次，\n" +
                        "當天使用有效日期2021.11.17(8/17進貨)",
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"4",
                    "name":"美國加州杏仁果",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"信和股份有限公司",
                    "importer":"信和股份有限公司",
                    "manufacturer":"RPAC,LLC",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":4,
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"5",
                    "name":"美國加州杏仁果",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"信和股份有限公司",
                    "importer":"信和股份有限公司",
                    "manufacturer":"VANN FAMLLY ORCHARDS",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":5,
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"6",
                    "name":"甜扁桃仁粒",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"成久旺股份有限公司",
                    "importer":"成久旺股份有限公司",
                    "manufacturer":"TWIN COMMODITIES,INC.",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":6,
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"7",
                    "name":"帶皮杏仁粒",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"昇祥股份有限公司",
                    "importer":"昇祥股份有限公司",
                    "manufacturer":"美國加州皮爾農場公司",
                    "originPlace":"美國加州",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":7,
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"8",
                    "name":"有機生糙米粉(台灣)",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"青田農產有限公司",
                    "importer":"",
                    "manufacturer":"青田農產有限公司",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":8,
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"9",
                    "name":"精製椰子油",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"禾發實業有限公司",
                    "importer":"禾發實業有限公司",
                    "manufacturer":"OLEO-FATS, INCORPORATED",
                    "originPlace":"菲律賓",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":9,
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"10",
                    "name":"杏仁細粉",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"迦得貿易實業有限公司",
                    "importer":"迦得貿易實業有限公司",
                    "manufacturer":"Treehouse California Almonds LLC",
                    "originPlace":"菲律賓",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":10,
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"11",
                    "name":"杏仁粉(細)",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"成久旺股份有限公司",
                    "importer":"成久旺股份有限公司",
                    "manufacturer":"Treehouse California Almonds LLC",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":11,
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"12",
                    "name":"混合濃縮生育醇",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"信意企業股份有限公司",
                    "importer":"信意企業股份有限公司",
                    "manufacturer":"CARGILL INCORPORATED",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"衛部添製字第002764號/TFAA1N002764004",
                    "processingAid":"N",
                    "accessory":"N",
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                }
            ],
            "tseyueRawMaterials":[
                {
                    "id":"1",
                    "type":"material",
                    "name":"玉米粉",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"乖乖",
                    "importer":"",
                    "manufacturer":"乖乖",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "addRatio":9,
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":1,
                    "validityAndSituation":"有效日期：2022/3/15",
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"2",
                    "type":"material",
                    "name":"精製特砂",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"台糖",
                    "manufacturer":"台糖",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":2,
                    "validityAndSituation":"有效日期：2023/04/18",
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"3",
                    "name":"二次精製軟棕油",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"福懋油脂",
                    "manufacturer":"福懋油脂",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":3,
                    "validityAndSituation":"有效日期：2023/07/09",
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                }
            ]
        },
        "summaryReport":[
            {
                "carNo":"INS01-01",
                "ncrType":"primary",
                "checkItems":["02-1","04-2"],
                "observation":"廠外環境污染源現況與申請資料描述不一致",
                "nextInspectionFocus":true,
                "reviewResult":"correct",
                "reviewersOpinions":[
                    {
                        "reviewer":"王小明",
                        "nextInspectionFocus":true,
                        "reviewResult":"correct",
                        "comment":"Gurman 並且稱該頭戴裝置「最快 2022」年可以到來，而且未來蘋果也會推出「單純 AR」的機種，但那要再多等幾年才會來臨了"
                    },
                    {
                        "reviewer":"王大同",
                        "nextInspectionFocus":true,
                        "reviewResult":"correct",
                        "comment":"眾人在期待的，更多還是蘋果能不能利用其格外強大的產品開發與行銷能力，將 MR 帶進主流"
                    }
                ],
                "correctionActionPlan":"修正校驗範圍，使其涵蓋量測範圍",
                "estimatedImprovementDate":"2021-07-31T08:20:10.000Z",
                "evaluateCorrectiveAction":"agree",
                "evaluationContent":"確認已修改完成",
                "correctionHistories":[
                    {"replyDate":"2021-09-18T08:20:10.000","correctionActionPlan":"規劃加強清潔次數","estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-19T08:20:10.000","evaluationContent":"請提供具體計畫內容"},
                    {"replyDate":"2021-09-21T08:20:10.000","correctionActionPlan":"規劃每週清潔次數由1次改成2次", "estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-22T08:20:10.000","evaluationContent":"請說明預計開始實施日期"}
                ],
            },
            {
                "carNo":"INS01-02",
                "ncrType":"secondary",
                "checkItems":["03-1"],
                "observation":"客戶提供之評鑑場所平面圖與實際看到者不一致",
                "nextInspectionFocus":true,
                "reviewResult":"track",
                "reviewersOpinions":[
                    {
                        "reviewer":"王小明",
                        "nextInspectionFocus":true,
                        "reviewResult":"track",
                        "comment":"Gurman 並且稱該頭戴裝置「最快 2022」年可以到來，而且未來蘋果也會推出「單純 AR」的機種，但那要再多等幾年才會來臨了"
                    },
                    {
                        "reviewer":"王大同",
                        "nextInspectionFocus":true,
                        "reviewResult":"track",
                        "comment":"眾人在期待的，更多還是蘋果能不能利用其格外強大的產品開發與行銷能力，將 MR 帶進主流"
                    }
                ],
                "correctionActionPlan":"修正校驗範圍，使其涵蓋量測範圍",
                "estimatedImprovementDate":"2021-07-31T08:20:10.000Z",
                "evaluateCorrectiveAction":"agree",
                "evaluationContent":"確認已修改完成",
                "correctionHistories":[
                    {"replyDate":"2021-09-18T08:20:10.000","correctionActionPlan":"規劃加強清潔次數","estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-19T08:20:10.000","evaluationContent":"請提供具體計畫內容"},
                    {"replyDate":"2021-09-21T08:20:10.000","correctionActionPlan":"規劃每週清潔次數由1次改成2次", "estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-22T08:20:10.000","evaluationContent":"請說明預計開始實施日期"}
                ],
            },
            {
                "carNo":"INS01-03",
                "ncrType":"secondary",
                "checkItems":["06-1","06-2"],
                "observation":"原料相關證明文件或檢驗報告可與使用原料來源沒有勾稽",
                "reviewersOpinions":[
                    {
                        "reviewer":"王小明",
                        "nextInspectionFocus":true,
                        "reviewResult":"track",
                        "comment":"Gurman 並且稱該頭戴裝置「最快 2022」年可以到來，而且未來蘋果也會推出「單純 AR」的機種，但那要再多等幾年才會來臨了"
                    },
                    {
                        "reviewer":"王大同",
                        "reviewResult":"correct",
                        "comment":"眾人在期待的，更多還是蘋果能不能利用其格外強大的產品開發與行銷能力，將 MR 帶進主流"
                    }
                ],
                "correctionActionPlan":"修正校驗範圍，使其涵蓋量測範圍",
                "estimatedImprovementDate":"2021-07-31T08:20:10.000Z",
                "evaluateCorrectiveAction":"agree",
                "evaluationContent":"確認已修改完成",
                "correctionHistories":[
                    {"replyDate":"2021-09-18T08:20:10.000","correctionActionPlan":"規劃加強清潔次數","estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-19T08:20:10.000","evaluationContent":"請提供具體計畫內容"},
                    {"replyDate":"2021-09-21T08:20:10.000","correctionActionPlan":"規劃每週清潔次數由1次改成2次", "estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-22T08:20:10.000","evaluationContent":"請說明預計開始實施日期"}
                ],
            },
            {
                "carNo":"INS01-04",
                "checkItems":["06-3"],
                "ncrType":"secondary",
                "observation":"原材料進貨時沒有驗收紀錄",
                "nextInspectionFocus":true,
                "reviewResult":"track",
                "reviewersOpinions":[
                    {
                        "reviewer":"王小明",
                        "nextInspectionFocus":true,
                        "reviewResult":"track",
                        "comment":"Gurman 並且稱該頭戴裝置「最快 2022」年可以到來，而且未來蘋果也會推出「單純 AR」的機種，但那要再多等幾年才會來臨了"
                    },
                ],
                "correctionActionPlan":"修正校驗範圍，使其涵蓋量測範圍",
                "estimatedImprovementDate":"2021-07-31T08:20:10.000Z",
                "evaluateCorrectiveAction":"agree",
                "evaluationContent":"確認已修改完成",
                "correctionHistories":[
                    {"replyDate":"2021-09-18T08:20:10.000","correctionActionPlan":"規劃加強清潔次數","estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-19T08:20:10.000","evaluationContent":"請提供具體計畫內容"},
                    {"replyDate":"2021-09-21T08:20:10.000","correctionActionPlan":"規劃每週清潔次數由1次改成2次", "estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-22T08:20:10.000","evaluationContent":"請說明預計開始實施日期"}
                ],
            }
        ],
        "inspectionItemInfo":{
            "inspectionDates":[
                {"inspectionDate":"2021-09-13T16:00:00.000Z",
                    "arrivalTime": "2021-09-13T16:00:00.000Z",
                    "departureTime": "2021-09-13T16:00:00.000Z",
                    "inspectors":[
                        {"inspector":"王大同", "role":"lead"},
                        {"inspector":"張小明", "role":"inspector"},
                        {"inspector":"林小花", "role":"observer"}
                    ],
                    "weather": "sunny",
                },
                {"inspectionDate":"2021-09-15T16:00:00.000Z",
                    "arrivalTime": "2021-09-13T16:00:00.000Z",
                    "departureTime": "2021-09-13T16:00:00.000Z",
                    "inspectors":[
                        {"inspector":"吳小保", "role":"inspector"},
                        {"inspector":"林小花", "role":"observer"}
                    ],
                    "weather": "rainy",
                }
            ],
            "inspector":{
                "lead":"王大同",
                "inspector":["張小明","吳小保"],
                "observer":["林小花"]
            },
            "inspectionItems":[
                {
                    "section":"01",
                    "items":[
                        {
                            "itemCode":"1.1",
                            "result":"Y"
                        },
                        {
                            "itemCode":"1.2",
                            "result":"Y"
                        },
                        {
                            "itemCode":"1.3",
                            "ncrType":"secondary",
                            "result":"N",
                            "observation":"沒有持續全程在場"
                        },
                        {
                            "itemCode":"1.4",
                            "ncrType":"observation",
                            "result":"N",
                            "observation":"標籤微破損"
                        },
                        {
                            "itemCode":"1.5",
                            "result":"Y"
                        }
                    ]
                },
                {
                    "section":"02",
                    "items":[
                        {
                            "itemCode":"2.1",
                            "result":"Y"
                        },
                        {
                            "itemCode":"2.2",
                            "result":"Y"
                        },
                        {
                            "itemCode":"2.3",
                            "ncrType":"secondary",
                            "result":"N"
                        },
                        {
                            "itemCode":"2.4",
                            "result":"Y"
                        },
                        {
                            "itemCode":"2.5",
                        }
                    ]
                },
                {
                    "section":"03",
                    "items":[
                        {
                            "itemCode":"3.1"
                        },
                        {
                            "itemCode":"3.2"
                        },
                        {
                            "itemCode":"3.3"
                        },
                        {
                            "itemCode":"3.4"
                        },
                        {
                            "itemCode":"3.5"
                        },
                        {
                            "itemCode":"3.6",
                            "result":"Y"
                        },
                        {
                            "itemCode":"3.7",
                            "result":"Y"
                        },
                        {
                            "itemCode":"3.8",
                            "result":"Y"
                        },
                        {
                            "itemCode":"3.9",
                            "result":"Y"
                        },
                        {
                            "itemCode":"3.10",
                            "result":"Y"
                        },
                        {
                            "itemCode":"3.11",
                            "result":"Y"
                        },
                        {
                            "itemCode":"3.12",
                            "result":"Y"
                        },
                        {
                            "itemCode":"3.13",
                            "result":"Y"
                        },
                        {
                            "itemCode":"3.14"
                        }
                    ]
                },
                {
                    "section":"04",
                    "items":[
                        {
                            "itemCode":"4.1"
                        },
                        {
                            "itemCode":"4.2"
                        },
                        {
                            "itemCode":"4.3"
                        },
                        {
                            "itemCode":"4.4"
                        },
                        {
                            "itemCode":"4.5"
                        },
                        {
                            "itemCode":"4.6"
                        },
                        {
                            "itemCode":"4.7"
                        },
                        {
                            "itemCode":"4.8"
                        },
                        {
                            "itemCode":"4.9"
                        },
                        {
                            "itemCode":"4.10"
                        },
                        {
                            "itemCode":"4.11"
                        },
                        {
                            "itemCode":"4.12"
                        },
                        {
                            "itemCode":"4.13"
                        },
                        {
                            "itemCode":"4.14"
                        },
                        {
                            "itemCode":"4.15"
                        },
                        {
                            "itemCode":"4.16"
                        },
                        {
                            "itemCode":"4.17"
                        },
                    ]
                },
                {
                    "section":"05",
                    "items":[
                        {
                            "itemCode":"5.1"
                        },
                        {
                            "itemCode":"5.2"
                        },
                        {
                            "itemCode":"5.3"
                        },
                        {
                            "itemCode":"5.4"
                        },
                        {
                            "itemCode":"5.5"
                        },
                        {
                            "itemCode":"5.6"
                        },
                        {
                            "itemCode":"5.7"
                        },
                        {
                            "itemCode":"5.8"
                        },
                        {
                            "itemCode":"5.9"
                        },
                        {
                            "itemCode":"5.10"
                        },
                    ]
                },
                {
                    "section":"06",
                    "items":[
                        {
                            "itemCode":"6.1"
                        },
                        {
                            "itemCode":"6.2"
                        },
                        {
                            "itemCode":"6.3"
                        },
                        {
                            "itemCode":"6.4"
                        },
                        {
                            "itemCode":"6.5"
                        },
                        {
                            "itemCode":"6.6"
                        },
                        {
                            "itemCode":"6.7"
                        },
                        {
                            "itemCode":"6.8"
                        },
                        {
                            "itemCode":"6.9"
                        },
                        {
                            "itemCode":"6.10"
                        },
                        {
                            "itemCode":"6.11"
                        },
                        {
                            "itemCode":"6.12"
                        },
                        {
                            "itemCode":"6.13"
                        },
                        {
                            "itemCode":"6.14"
                        },
                        {
                            "itemCode":"6.15"
                        },
                        {
                            "itemCode":"6.16"
                        },
                        {
                            "itemCode":"6.17"
                        },
                        {
                            "itemCode":"6.18"
                        },
                        {
                            "itemCode":"6.19"
                        },
                        {
                            "itemCode":"6.20"
                        },
                    ]
                },
                {
                    "section":"07",
                    "items":[
                        {
                            "itemCode":"7.1"
                        },
                        {
                            "itemCode":"7.2"
                        },
                        {
                            "itemCode":"7.3"
                        },
                        {
                            "itemCode":"7.4"
                        },
                        {
                            "itemCode":"7.5"
                        },
                        {
                            "itemCode":"7.6"
                        },
                        {
                            "itemCode":"7.7"
                        },
                        {
                            "itemCode":"7.8"
                        },
                        {
                            "itemCode":"7.9"
                        }
                    ]
                },
                {
                    "section":"08",
                    "items":[
                        {
                            "itemCode":"8.1"
                        },
                        {
                            "itemCode":"8.2"
                        },
                        {
                            "itemCode":"8.3"
                        },
                        {
                            "itemCode":"8.4"
                        },
                        {
                            "itemCode":"8.5"
                        },
                        {
                            "itemCode":"8.6"
                        },
                        {
                            "itemCode":"8.7"
                        },
                        {
                            "itemCode":"8.8"
                        },
                        {
                            "itemCode":"8.9"
                        },
                        {
                            "itemCode":"8.10"
                        },
                        {
                            "itemCode":"8.11"
                        },
                        {
                            "itemCode":"8.12"
                        },
                        {
                            "itemCode":"8.13"
                        },
                        {
                            "itemCode":"8.14"
                        },
                        {
                            "itemCode":"8.15"
                        },
                        {
                            "itemCode":"8.16"
                        },
                        {
                            "itemCode":"8.17"
                        }
                    ]
                },
                {
                    "section":"09",
                    "items":[
                        {
                            "itemCode":"9.1"
                        },
                        {
                            "itemCode":"9.2"
                        },
                        {
                            "itemCode":"9.3"
                        },
                    ]
                }
            ]
        }
    },
    {
        "id": "2",
        "appNo": "A21080213",
        "appType": "initial",
        "customerNo": "0032",
        "customerName": "源天然股份有限公司",
        "assessmentPlace": "屏東廠",
        "decision": "reject",
        "inspectionDate": "2022-01-05T00:00:00.000Z",
        "suggestions": [
            {"suggestion": "建議事項1.............................."},
            {"suggestion": "建議事項2.............................."}
        ],
        "notices": [
            {"notice": "注意事項1..............................."},
            {"notice": "注意事項2..............................."},
            {"notice": "注意事項3..............................."}
        ],
        "inspectionContent":{
            "standard":"leezen",
            "inspectionItems":[
                {"productionLine":"line1", "products":["Natural Benefits 食安生技-椰子汁"]},
                {"productionLine":"line2", "products":["杏仁玄米餅","核桃酥"]}
            ],
            "inspectionScope":"評鑑產品之評鑑場所場區環境與衛生管理、製程與品質管制、原料查驗、相關檢驗報告與紀錄表單核對等，及前次所列查驗重點之執行狀況確認"
        },
        "inspectionResult":{
            "previousNcrs":[
                {
                    "appNo":"A20080111",
                    "type":"secondary",
                    "inspectionItem":"03-3",
                    "observationDesc":"碳酸鈣550g/包,未涵蓋使用範圍"
                },
                {
                    "appNo":"A20080111",
                    "type":"secondary",
                    "inspectionItem":"06-1",
                    "observationDesc":"評鑑產品之評鑑場所場區環境與衛生管理、製程與品質管制"
                }
            ],
            "productChangeInspectionKeyNote":"1.員工衛生新進食品從業人員應先經醫療機構健康檢查合格後，始得聘僱；雇主每年應主動辦理健康檢查至少一次。\n" +
                "2.員工教育訓練：新進食品從業人員應接受適當之教育訓練，使其執行能力符合生產、衛生及品質管理之要求；在職從業人員，應定期接受食品安全、衛生及品質管理之教育訓練，並作成紀錄。",
            "leezenRawMaterials":[
                {
                    "id":"1",
                    "type":"material",
                    "name":"豆蓉粉(新版)",
                    "storageCondition":"roomTemperature",
                    "composition":"水、非基因改造脫脂黃豆片、小麥、食鹽、轉化液糖(蔗糖、水)、調味劑(DL-蘋果酸)",
                    "domesticVendor":"穎昌食品有限公司(新和美)",
                    "importer":"",
                    "manufacturer":"穎昌食品有限公司(新和美)",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "addRatio":9,
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":1,
                    "validityAndSituation":"有效日期：2022/03/19(此批非里仁使用)",
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"2",
                    "type":"material",
                    "name":"美國加州杏仁果",
                    "storageCondition":"roomTemperature",
                    "composition":"樹薯澱粉、水(原料)",
                    "domesticVendor":"信成股份有限公司",
                    "importer":"信成股份有限公司",
                    "manufacturer":"TERRA NOVA TRADING INC.",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":2,
                    "validityAndSituation":"有效日期：2023/04/18",
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"3",
                    "name":"美國加州杏仁果",
                    "storageCondition":"refrigeration",
                    "composition":"植物油脂(菜籽油)、洋蔥、葡萄糖、抗氧化劑(維生素C、混合濃縮生育醇)",
                    "domesticVendor":"爾邦得有限公司",
                    "importer":"爾邦得有限公司",
                    "manufacturer":"TERRA NOVA TRADING INC.",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":3,
                    "validityAndSituation":"槽車運送日期2021/09/14(保存期限3個月)，平均約1個月左右進貨一次，\n" +
                        "當天使用有效日期2021.11.17(8/17進貨)",
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"4",
                    "name":"美國加州杏仁果",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"信和股份有限公司",
                    "importer":"信和股份有限公司",
                    "manufacturer":"RPAC,LLC",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":4,
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"5",
                    "name":"美國加州杏仁果",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"信和股份有限公司",
                    "importer":"信和股份有限公司",
                    "manufacturer":"VANN FAMLLY ORCHARDS",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":5,
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"6",
                    "name":"甜扁桃仁粒",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"成久旺股份有限公司",
                    "importer":"成久旺股份有限公司",
                    "manufacturer":"TWIN COMMODITIES,INC.",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":6,
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"7",
                    "name":"帶皮杏仁粒",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"昇祥股份有限公司",
                    "importer":"昇祥股份有限公司",
                    "manufacturer":"美國加州皮爾農場公司",
                    "originPlace":"美國加州",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":7,
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"8",
                    "name":"有機生糙米粉(台灣)",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"青田農產有限公司",
                    "importer":"",
                    "manufacturer":"青田農產有限公司",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":8,
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"9",
                    "name":"精製椰子油",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"禾發實業有限公司",
                    "importer":"禾發實業有限公司",
                    "manufacturer":"OLEO-FATS, INCORPORATED",
                    "originPlace":"菲律賓",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":9,
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"10",
                    "name":"杏仁細粉",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"迦得貿易實業有限公司",
                    "importer":"迦得貿易實業有限公司",
                    "manufacturer":"Treehouse California Almonds LLC",
                    "originPlace":"菲律賓",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":10,
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"11",
                    "name":"杏仁粉(細)",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"成久旺股份有限公司",
                    "importer":"成久旺股份有限公司",
                    "manufacturer":"Treehouse California Almonds LLC",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":11,
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"12",
                    "name":"混合濃縮生育醇",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"信意企業股份有限公司",
                    "importer":"信意企業股份有限公司",
                    "manufacturer":"CARGILL INCORPORATED",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"衛部添製字第002764號/TFAA1N002764004",
                    "processingAid":"N",
                    "accessory":"N",
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                }
            ],
            "tseyueRawMaterials":[
                {
                    "id":"1",
                    "type":"material",
                    "name":"玉米粉",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"乖乖",
                    "importer":"",
                    "manufacturer":"乖乖",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "addRatio":9,
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":1,
                    "validityAndSituation":"有效日期：2022/3/15",
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"2",
                    "type":"material",
                    "name":"精製特砂",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"台糖",
                    "manufacturer":"台糖",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":2,
                    "validityAndSituation":"有效日期：2023/04/18",
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"3",
                    "name":"二次精製軟棕油",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"福懋油脂",
                    "manufacturer":"福懋油脂",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":3,
                    "validityAndSituation":"有效日期：2023/07/09",
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                }
            ]
        },
        "summaryReport":[
            {
                "carNo":"INS01-01",
                "ncrType":"primary",
                "checkItems":["02-1","04-2"],
                "observation":"廠外環境污染源現況與申請資料描述不一致",
                "nextInspectionFocus":true,
                "reviewResult":"correct",
                "reviewersOpinions":[
                    {
                        "reviewer":"王小明",
                        "nextInspectionFocus":true,
                        "reviewResult":"correct",
                        "comment":"Gurman 並且稱該頭戴裝置「最快 2022」年可以到來，而且未來蘋果也會推出「單純 AR」的機種，但那要再多等幾年才會來臨了"
                    },
                    {
                        "reviewer":"王大同",
                        "nextInspectionFocus":true,
                        "reviewResult":"correct",
                        "comment":"眾人在期待的，更多還是蘋果能不能利用其格外強大的產品開發與行銷能力，將 MR 帶進主流"
                    }
                ],
                "correctionActionPlan":"修正校驗範圍，使其涵蓋量測範圍",
                "estimatedImprovementDate":"2021-07-31T08:20:10.000Z",
                "evaluateCorrectiveAction":"agree",
                "evaluationContent":"確認已修改完成",
                "correctionHistories":[
                    {"replyDate":"2021-09-18T08:20:10.000","correctionActionPlan":"規劃加強清潔次數","estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-19T08:20:10.000","evaluationContent":"請提供具體計畫內容"},
                    {"replyDate":"2021-09-21T08:20:10.000","correctionActionPlan":"規劃每週清潔次數由1次改成2次", "estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-22T08:20:10.000","evaluationContent":"請說明預計開始實施日期"}
                ],
            },
            {
                "carNo":"INS01-02",
                "ncrType":"secondary",
                "checkItems":["03-1"],
                "observation":"客戶提供之評鑑場所平面圖與實際看到者不一致",
                "nextInspectionFocus":true,
                "reviewResult":"track",
                "reviewersOpinions":[
                    {
                        "reviewer":"王小明",
                        "nextInspectionFocus":true,
                        "reviewResult":"track",
                        "comment":"Gurman 並且稱該頭戴裝置「最快 2022」年可以到來，而且未來蘋果也會推出「單純 AR」的機種，但那要再多等幾年才會來臨了"
                    },
                    {
                        "reviewer":"王大同",
                        "nextInspectionFocus":true,
                        "reviewResult":"track",
                        "comment":"眾人在期待的，更多還是蘋果能不能利用其格外強大的產品開發與行銷能力，將 MR 帶進主流"
                    }
                ],
                "correctionActionPlan":"修正校驗範圍，使其涵蓋量測範圍",
                "estimatedImprovementDate":"2021-07-31T08:20:10.000Z",
                "evaluateCorrectiveAction":"agree",
                "evaluationContent":"確認已修改完成",
                "correctionHistories":[
                    {"replyDate":"2021-09-18T08:20:10.000","correctionActionPlan":"規劃加強清潔次數","estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-19T08:20:10.000","evaluationContent":"請提供具體計畫內容"},
                    {"replyDate":"2021-09-21T08:20:10.000","correctionActionPlan":"規劃每週清潔次數由1次改成2次", "estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-22T08:20:10.000","evaluationContent":"請說明預計開始實施日期"}
                ],
            },
            {
                "carNo":"INS01-03",
                "ncrType":"secondary",
                "checkItems":["06-1","06-2"],
                "observation":"原料相關證明文件或檢驗報告可與使用原料來源沒有勾稽",
                "reviewersOpinions":[
                    {
                        "reviewer":"王小明",
                        "nextInspectionFocus":true,
                        "reviewResult":"track",
                        "comment":"Gurman 並且稱該頭戴裝置「最快 2022」年可以到來，而且未來蘋果也會推出「單純 AR」的機種，但那要再多等幾年才會來臨了"
                    },
                    {
                        "reviewer":"王大同",
                        "reviewResult":"correct",
                        "comment":"眾人在期待的，更多還是蘋果能不能利用其格外強大的產品開發與行銷能力，將 MR 帶進主流"
                    }
                ],
                "correctionActionPlan":"修正校驗範圍，使其涵蓋量測範圍",
                "estimatedImprovementDate":"2021-07-31T08:20:10.000Z",
                "evaluateCorrectiveAction":"agree",
                "evaluationContent":"確認已修改完成",
                "correctionHistories":[
                    {"replyDate":"2021-09-18T08:20:10.000","correctionActionPlan":"規劃加強清潔次數","estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-19T08:20:10.000","evaluationContent":"請提供具體計畫內容"},
                    {"replyDate":"2021-09-21T08:20:10.000","correctionActionPlan":"規劃每週清潔次數由1次改成2次", "estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-22T08:20:10.000","evaluationContent":"請說明預計開始實施日期"}
                ],
            },
            {
                "carNo":"INS01-04",
                "checkItems":["06-3"],
                "ncrType":"secondary",
                "observation":"原材料進貨時沒有驗收紀錄",
                "nextInspectionFocus":true,
                "reviewResult":"track",
                "reviewersOpinions":[
                    {
                        "reviewer":"王小明",
                        "nextInspectionFocus":true,
                        "reviewResult":"track",
                        "comment":"Gurman 並且稱該頭戴裝置「最快 2022」年可以到來，而且未來蘋果也會推出「單純 AR」的機種，但那要再多等幾年才會來臨了"
                    },
                ],
                "correctionActionPlan":"修正校驗範圍，使其涵蓋量測範圍",
                "estimatedImprovementDate":"2021-07-31T08:20:10.000Z",
                "evaluateCorrectiveAction":"agree",
                "evaluationContent":"確認已修改完成",
                "correctionHistories":[
                    {"replyDate":"2021-09-18T08:20:10.000","correctionActionPlan":"規劃加強清潔次數","estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-19T08:20:10.000","evaluationContent":"請提供具體計畫內容"},
                    {"replyDate":"2021-09-21T08:20:10.000","correctionActionPlan":"規劃每週清潔次數由1次改成2次", "estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-22T08:20:10.000","evaluationContent":"請說明預計開始實施日期"}
                ],
            }
        ],
        "inspectionItemInfo":{
            "inspectionDates":[
                {"inspectionDate":"2021-09-13T16:00:00.000Z",
                    "arrivalTime": "2021-09-13T16:00:00.000Z",
                    "departureTime": "2021-09-13T16:00:00.000Z",
                    "inspectors":[
                        {"inspector":"王大同", "role":"lead"},
                        {"inspector":"張小明", "role":"inspector"},
                        {"inspector":"林小花", "role":"observer"}
                    ],
                    "weather": "sunny",
                },
                {"inspectionDate":"2021-09-15T16:00:00.000Z",
                    "arrivalTime": "2021-09-13T16:00:00.000Z",
                    "departureTime": "2021-09-13T16:00:00.000Z",
                    "inspectors":[
                        {"inspector":"吳小保", "role":"inspector"},
                        {"inspector":"林小花", "role":"observer"}
                    ],
                    "weather": "rainy",
                }
            ],
            "inspector":{
                "lead":"王大同",
                "inspector":["張小明","吳小保"],
                "observer":["林小花"]
            },
            "inspectionItems":[
                {
                    "section":"01",
                    "items":[
                        {
                            "itemCode":"1.1",
                            "result":"Y"
                        },
                        {
                            "itemCode":"1.2",
                            "result":"Y"
                        },
                        {
                            "itemCode":"1.3",
                            "ncrType":"secondary",
                            "result":"N",
                            "observation":"沒有持續全程在場"
                        },
                        {
                            "itemCode":"1.4",
                            "ncrType":"observation",
                            "result":"N",
                            "observation":"標籤微破損"
                        },
                        {
                            "itemCode":"1.5",
                            "result":"Y"
                        }
                    ]
                },
                {
                    "section":"02",
                    "items":[
                        {
                            "itemCode":"2.1",
                            "result":"Y"
                        },
                        {
                            "itemCode":"2.2",
                            "result":"Y"
                        },
                        {
                            "itemCode":"2.3",
                            "ncrType":"secondary",
                            "result":"N"
                        },
                        {
                            "itemCode":"2.4",
                            "result":"Y"
                        },
                        {
                            "itemCode":"2.5",
                        }
                    ]
                },
                {
                    "section":"03",
                    "items":[
                        {
                            "itemCode":"3.1"
                        },
                        {
                            "itemCode":"3.2"
                        },
                        {
                            "itemCode":"3.3"
                        },
                        {
                            "itemCode":"3.4"
                        },
                        {
                            "itemCode":"3.5"
                        },
                        {
                            "itemCode":"3.6",
                            "result":"Y"
                        },
                        {
                            "itemCode":"3.7",
                            "result":"Y"
                        },
                        {
                            "itemCode":"3.8",
                            "result":"Y"
                        },
                        {
                            "itemCode":"3.9",
                            "result":"Y"
                        },
                        {
                            "itemCode":"3.10",
                            "result":"Y"
                        },
                        {
                            "itemCode":"3.11",
                            "result":"Y"
                        },
                        {
                            "itemCode":"3.12",
                            "result":"Y"
                        },
                        {
                            "itemCode":"3.13",
                            "result":"Y"
                        },
                        {
                            "itemCode":"3.14"
                        }
                    ]
                },
                {
                    "section":"04",
                    "items":[
                        {
                            "itemCode":"4.1"
                        },
                        {
                            "itemCode":"4.2"
                        },
                        {
                            "itemCode":"4.3"
                        },
                        {
                            "itemCode":"4.4"
                        },
                        {
                            "itemCode":"4.5"
                        },
                        {
                            "itemCode":"4.6"
                        },
                        {
                            "itemCode":"4.7"
                        },
                        {
                            "itemCode":"4.8"
                        },
                        {
                            "itemCode":"4.9"
                        },
                        {
                            "itemCode":"4.10"
                        },
                        {
                            "itemCode":"4.11"
                        },
                        {
                            "itemCode":"4.12"
                        },
                        {
                            "itemCode":"4.13"
                        },
                        {
                            "itemCode":"4.14"
                        },
                        {
                            "itemCode":"4.15"
                        },
                        {
                            "itemCode":"4.16"
                        },
                        {
                            "itemCode":"4.17"
                        },
                    ]
                },
                {
                    "section":"05",
                    "items":[
                        {
                            "itemCode":"5.1"
                        },
                        {
                            "itemCode":"5.2"
                        },
                        {
                            "itemCode":"5.3"
                        },
                        {
                            "itemCode":"5.4"
                        },
                        {
                            "itemCode":"5.5"
                        },
                        {
                            "itemCode":"5.6"
                        },
                        {
                            "itemCode":"5.7"
                        },
                        {
                            "itemCode":"5.8"
                        },
                        {
                            "itemCode":"5.9"
                        },
                        {
                            "itemCode":"5.10"
                        },
                    ]
                },
                {
                    "section":"06",
                    "items":[
                        {
                            "itemCode":"6.1"
                        },
                        {
                            "itemCode":"6.2"
                        },
                        {
                            "itemCode":"6.3"
                        },
                        {
                            "itemCode":"6.4"
                        },
                        {
                            "itemCode":"6.5"
                        },
                        {
                            "itemCode":"6.6"
                        },
                        {
                            "itemCode":"6.7"
                        },
                        {
                            "itemCode":"6.8"
                        },
                        {
                            "itemCode":"6.9"
                        },
                        {
                            "itemCode":"6.10"
                        },
                        {
                            "itemCode":"6.11"
                        },
                        {
                            "itemCode":"6.12"
                        },
                        {
                            "itemCode":"6.13"
                        },
                        {
                            "itemCode":"6.14"
                        },
                        {
                            "itemCode":"6.15"
                        },
                        {
                            "itemCode":"6.16"
                        },
                        {
                            "itemCode":"6.17"
                        },
                        {
                            "itemCode":"6.18"
                        },
                        {
                            "itemCode":"6.19"
                        },
                        {
                            "itemCode":"6.20"
                        },
                    ]
                },
                {
                    "section":"07",
                    "items":[
                        {
                            "itemCode":"7.1"
                        },
                        {
                            "itemCode":"7.2"
                        },
                        {
                            "itemCode":"7.3"
                        },
                        {
                            "itemCode":"7.4"
                        },
                        {
                            "itemCode":"7.5"
                        },
                        {
                            "itemCode":"7.6"
                        },
                        {
                            "itemCode":"7.7"
                        },
                        {
                            "itemCode":"7.8"
                        },
                        {
                            "itemCode":"7.9"
                        }
                    ]
                },
                {
                    "section":"08",
                    "items":[
                        {
                            "itemCode":"8.1"
                        },
                        {
                            "itemCode":"8.2"
                        },
                        {
                            "itemCode":"8.3"
                        },
                        {
                            "itemCode":"8.4"
                        },
                        {
                            "itemCode":"8.5"
                        },
                        {
                            "itemCode":"8.6"
                        },
                        {
                            "itemCode":"8.7"
                        },
                        {
                            "itemCode":"8.8"
                        },
                        {
                            "itemCode":"8.9"
                        },
                        {
                            "itemCode":"8.10"
                        },
                        {
                            "itemCode":"8.11"
                        },
                        {
                            "itemCode":"8.12"
                        },
                        {
                            "itemCode":"8.13"
                        },
                        {
                            "itemCode":"8.14"
                        },
                        {
                            "itemCode":"8.15"
                        },
                        {
                            "itemCode":"8.16"
                        },
                        {
                            "itemCode":"8.17"
                        }
                    ]
                },
                {
                    "section":"09",
                    "items":[
                        {
                            "itemCode":"9.1"
                        },
                        {
                            "itemCode":"9.2"
                        },
                        {
                            "itemCode":"9.3"
                        },
                    ]
                }
            ]
        }
    },
    {
        "id": "3",
        "appNo": "A21081515",
        "appType": "followUp",
        "customerNo": "0016",
        "customerName": "豆之家食品有限公司",
        "assessmentPlace": "台南廠",
        "decision": "suspend",
        "inspectionDate": "2022-01-05T00:00:00.000Z",
        "suggestions": [
            {"suggestion": "建議事項1.............................."},
            {"suggestion": "建議事項2.............................."}
        ],
        "notices": [
            {"notice": "注意事項1..............................."},
            {"notice": "注意事項2..............................."},
            {"notice": "注意事項3..............................."}
        ],
        "inspectionContent":{
            "standard":"leezen",
            "inspectionItems":[
                {"productionLine":"line1", "products":["Natural Benefits 食安生技-椰子汁"]},
                {"productionLine":"line2", "products":["杏仁玄米餅","核桃酥"]}
            ],
            "inspectionScope":"評鑑產品之評鑑場所場區環境與衛生管理、製程與品質管制、原料查驗、相關檢驗報告與紀錄表單核對等，及前次所列查驗重點之執行狀況確認"
        },
        "inspectionResult":{
            "previousNcrs":[
                {
                    "appNo":"A20080111",
                    "type":"secondary",
                    "inspectionItem":"03-3",
                    "observationDesc":"碳酸鈣550g/包,未涵蓋使用範圍"
                },
                {
                    "appNo":"A20080111",
                    "type":"secondary",
                    "inspectionItem":"06-1",
                    "observationDesc":"評鑑產品之評鑑場所場區環境與衛生管理、製程與品質管制"
                }
            ],
            "productChangeInspectionKeyNote":"1.員工衛生新進食品從業人員應先經醫療機構健康檢查合格後，始得聘僱；雇主每年應主動辦理健康檢查至少一次。\n" +
                "2.員工教育訓練：新進食品從業人員應接受適當之教育訓練，使其執行能力符合生產、衛生及品質管理之要求；在職從業人員，應定期接受食品安全、衛生及品質管理之教育訓練，並作成紀錄。",
            "leezenRawMaterials":[
                {
                    "id":"1",
                    "type":"material",
                    "name":"豆蓉粉(新版)",
                    "storageCondition":"roomTemperature",
                    "composition":"水、非基因改造脫脂黃豆片、小麥、食鹽、轉化液糖(蔗糖、水)、調味劑(DL-蘋果酸)",
                    "domesticVendor":"穎昌食品有限公司(新和美)",
                    "importer":"",
                    "manufacturer":"穎昌食品有限公司(新和美)",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "addRatio":9,
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":1,
                    "validityAndSituation":"有效日期：2022/03/19(此批非里仁使用)",
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"2",
                    "type":"material",
                    "name":"美國加州杏仁果",
                    "storageCondition":"roomTemperature",
                    "composition":"樹薯澱粉、水(原料)",
                    "domesticVendor":"信成股份有限公司",
                    "importer":"信成股份有限公司",
                    "manufacturer":"TERRA NOVA TRADING INC.",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":2,
                    "validityAndSituation":"有效日期：2023/04/18",
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"3",
                    "name":"美國加州杏仁果",
                    "storageCondition":"refrigeration",
                    "composition":"植物油脂(菜籽油)、洋蔥、葡萄糖、抗氧化劑(維生素C、混合濃縮生育醇)",
                    "domesticVendor":"爾邦得有限公司",
                    "importer":"爾邦得有限公司",
                    "manufacturer":"TERRA NOVA TRADING INC.",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":3,
                    "validityAndSituation":"槽車運送日期2021/09/14(保存期限3個月)，平均約1個月左右進貨一次，\n" +
                        "當天使用有效日期2021.11.17(8/17進貨)",
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"4",
                    "name":"美國加州杏仁果",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"信和股份有限公司",
                    "importer":"信和股份有限公司",
                    "manufacturer":"RPAC,LLC",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":4,
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"5",
                    "name":"美國加州杏仁果",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"信和股份有限公司",
                    "importer":"信和股份有限公司",
                    "manufacturer":"VANN FAMLLY ORCHARDS",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":5,
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"6",
                    "name":"甜扁桃仁粒",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"成久旺股份有限公司",
                    "importer":"成久旺股份有限公司",
                    "manufacturer":"TWIN COMMODITIES,INC.",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":6,
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"7",
                    "name":"帶皮杏仁粒",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"昇祥股份有限公司",
                    "importer":"昇祥股份有限公司",
                    "manufacturer":"美國加州皮爾農場公司",
                    "originPlace":"美國加州",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":7,
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"8",
                    "name":"有機生糙米粉(台灣)",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"青田農產有限公司",
                    "importer":"",
                    "manufacturer":"青田農產有限公司",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":8,
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"9",
                    "name":"精製椰子油",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"禾發實業有限公司",
                    "importer":"禾發實業有限公司",
                    "manufacturer":"OLEO-FATS, INCORPORATED",
                    "originPlace":"菲律賓",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":9,
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"10",
                    "name":"杏仁細粉",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"迦得貿易實業有限公司",
                    "importer":"迦得貿易實業有限公司",
                    "manufacturer":"Treehouse California Almonds LLC",
                    "originPlace":"菲律賓",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":10,
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"11",
                    "name":"杏仁粉(細)",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"成久旺股份有限公司",
                    "importer":"成久旺股份有限公司",
                    "manufacturer":"Treehouse California Almonds LLC",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":11,
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"12",
                    "name":"混合濃縮生育醇",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"信意企業股份有限公司",
                    "importer":"信意企業股份有限公司",
                    "manufacturer":"CARGILL INCORPORATED",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"衛部添製字第002764號/TFAA1N002764004",
                    "processingAid":"N",
                    "accessory":"N",
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                }
            ],
            "tseyueRawMaterials":[
                {
                    "id":"1",
                    "type":"material",
                    "name":"玉米粉",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"乖乖",
                    "importer":"",
                    "manufacturer":"乖乖",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "addRatio":9,
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":1,
                    "validityAndSituation":"有效日期：2022/3/15",
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"2",
                    "type":"material",
                    "name":"精製特砂",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"台糖",
                    "manufacturer":"台糖",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":2,
                    "validityAndSituation":"有效日期：2023/04/18",
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"3",
                    "name":"二次精製軟棕油",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"福懋油脂",
                    "manufacturer":"福懋油脂",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":3,
                    "validityAndSituation":"有效日期：2023/07/09",
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                }
            ]
        },
        "summaryReport":[
            {
                "carNo":"INS01-01",
                "ncrType":"primary",
                "checkItems":["02-1","04-2"],
                "observation":"廠外環境污染源現況與申請資料描述不一致",
                "nextInspectionFocus":true,
                "reviewResult":"correct",
                "reviewersOpinions":[
                    {
                        "reviewer":"王小明",
                        "nextInspectionFocus":true,
                        "reviewResult":"correct",
                        "comment":"Gurman 並且稱該頭戴裝置「最快 2022」年可以到來，而且未來蘋果也會推出「單純 AR」的機種，但那要再多等幾年才會來臨了"
                    },
                    {
                        "reviewer":"王大同",
                        "nextInspectionFocus":true,
                        "reviewResult":"correct",
                        "comment":"眾人在期待的，更多還是蘋果能不能利用其格外強大的產品開發與行銷能力，將 MR 帶進主流"
                    }
                ],
                "correctionActionPlan":"修正校驗範圍，使其涵蓋量測範圍",
                "estimatedImprovementDate":"2021-07-31T08:20:10.000Z",
                "evaluateCorrectiveAction":"agree",
                "evaluationContent":"確認已修改完成",
                "correctionHistories":[
                    {"replyDate":"2021-09-18T08:20:10.000","correctionActionPlan":"規劃加強清潔次數","estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-19T08:20:10.000","evaluationContent":"請提供具體計畫內容"},
                    {"replyDate":"2021-09-21T08:20:10.000","correctionActionPlan":"規劃每週清潔次數由1次改成2次", "estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-22T08:20:10.000","evaluationContent":"請說明預計開始實施日期"}
                ],
            },
            {
                "carNo":"INS01-02",
                "ncrType":"secondary",
                "checkItems":["03-1"],
                "observation":"客戶提供之評鑑場所平面圖與實際看到者不一致",
                "nextInspectionFocus":true,
                "reviewResult":"track",
                "reviewersOpinions":[
                    {
                        "reviewer":"王小明",
                        "nextInspectionFocus":true,
                        "reviewResult":"track",
                        "comment":"Gurman 並且稱該頭戴裝置「最快 2022」年可以到來，而且未來蘋果也會推出「單純 AR」的機種，但那要再多等幾年才會來臨了"
                    },
                    {
                        "reviewer":"王大同",
                        "nextInspectionFocus":true,
                        "reviewResult":"track",
                        "comment":"眾人在期待的，更多還是蘋果能不能利用其格外強大的產品開發與行銷能力，將 MR 帶進主流"
                    }
                ],
                "correctionActionPlan":"修正校驗範圍，使其涵蓋量測範圍",
                "estimatedImprovementDate":"2021-07-31T08:20:10.000Z",
                "evaluateCorrectiveAction":"agree",
                "evaluationContent":"確認已修改完成",
                "correctionHistories":[
                    {"replyDate":"2021-09-18T08:20:10.000","correctionActionPlan":"規劃加強清潔次數","estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-19T08:20:10.000","evaluationContent":"請提供具體計畫內容"},
                    {"replyDate":"2021-09-21T08:20:10.000","correctionActionPlan":"規劃每週清潔次數由1次改成2次", "estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-22T08:20:10.000","evaluationContent":"請說明預計開始實施日期"}
                ],
            },
            {
                "carNo":"INS01-03",
                "ncrType":"secondary",
                "checkItems":["06-1","06-2"],
                "observation":"原料相關證明文件或檢驗報告可與使用原料來源沒有勾稽",
                "reviewersOpinions":[
                    {
                        "reviewer":"王小明",
                        "nextInspectionFocus":true,
                        "reviewResult":"track",
                        "comment":"Gurman 並且稱該頭戴裝置「最快 2022」年可以到來，而且未來蘋果也會推出「單純 AR」的機種，但那要再多等幾年才會來臨了"
                    },
                    {
                        "reviewer":"王大同",
                        "reviewResult":"correct",
                        "comment":"眾人在期待的，更多還是蘋果能不能利用其格外強大的產品開發與行銷能力，將 MR 帶進主流"
                    }
                ],
                "correctionActionPlan":"修正校驗範圍，使其涵蓋量測範圍",
                "estimatedImprovementDate":"2021-07-31T08:20:10.000Z",
                "evaluateCorrectiveAction":"agree",
                "evaluationContent":"確認已修改完成",
                "correctionHistories":[
                    {"replyDate":"2021-09-18T08:20:10.000","correctionActionPlan":"規劃加強清潔次數","estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-19T08:20:10.000","evaluationContent":"請提供具體計畫內容"},
                    {"replyDate":"2021-09-21T08:20:10.000","correctionActionPlan":"規劃每週清潔次數由1次改成2次", "estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-22T08:20:10.000","evaluationContent":"請說明預計開始實施日期"}
                ],
            },
            {
                "carNo":"INS01-04",
                "checkItems":["06-3"],
                "ncrType":"secondary",
                "observation":"原材料進貨時沒有驗收紀錄",
                "nextInspectionFocus":true,
                "reviewResult":"track",
                "reviewersOpinions":[
                    {
                        "reviewer":"王小明",
                        "nextInspectionFocus":true,
                        "reviewResult":"track",
                        "comment":"Gurman 並且稱該頭戴裝置「最快 2022」年可以到來，而且未來蘋果也會推出「單純 AR」的機種，但那要再多等幾年才會來臨了"
                    },
                ],
                "correctionActionPlan":"修正校驗範圍，使其涵蓋量測範圍",
                "estimatedImprovementDate":"2021-07-31T08:20:10.000Z",
                "evaluateCorrectiveAction":"agree",
                "evaluationContent":"確認已修改完成",
                "correctionHistories":[
                    {"replyDate":"2021-09-18T08:20:10.000","correctionActionPlan":"規劃加強清潔次數","estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-19T08:20:10.000","evaluationContent":"請提供具體計畫內容"},
                    {"replyDate":"2021-09-21T08:20:10.000","correctionActionPlan":"規劃每週清潔次數由1次改成2次", "estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-22T08:20:10.000","evaluationContent":"請說明預計開始實施日期"}
                ],
            }
        ],
        "inspectionItemInfo":{
            "inspectionDates":[
                {"inspectionDate":"2021-09-13T16:00:00.000Z",
                    "arrivalTime": "2021-09-13T16:00:00.000Z",
                    "departureTime": "2021-09-13T16:00:00.000Z",
                    "inspectors":[
                        {"inspector":"王大同", "role":"lead"},
                        {"inspector":"張小明", "role":"inspector"},
                        {"inspector":"林小花", "role":"observer"}
                    ],
                    "weather": "sunny",
                },
                {"inspectionDate":"2021-09-15T16:00:00.000Z",
                    "arrivalTime": "2021-09-13T16:00:00.000Z",
                    "departureTime": "2021-09-13T16:00:00.000Z",
                    "inspectors":[
                        {"inspector":"吳小保", "role":"inspector"},
                        {"inspector":"林小花", "role":"observer"}
                    ],
                    "weather": "rainy",
                }
            ],
            "inspector":{
                "lead":"王大同",
                "inspector":["張小明","吳小保"],
                "observer":["林小花"]
            },
            "inspectionItems":[
                {
                    "section":"01",
                    "items":[
                        {
                            "itemCode":"1.1",
                            "result":"Y"
                        },
                        {
                            "itemCode":"1.2",
                            "result":"Y"
                        },
                        {
                            "itemCode":"1.3",
                            "ncrType":"secondary",
                            "result":"N",
                            "observation":"沒有持續全程在場"
                        },
                        {
                            "itemCode":"1.4",
                            "ncrType":"observation",
                            "result":"N",
                            "observation":"標籤微破損"
                        },
                        {
                            "itemCode":"1.5",
                            "result":"Y"
                        }
                    ]
                },
                {
                    "section":"02",
                    "items":[
                        {
                            "itemCode":"2.1",
                            "result":"Y"
                        },
                        {
                            "itemCode":"2.2",
                            "result":"Y"
                        },
                        {
                            "itemCode":"2.3",
                            "ncrType":"secondary",
                            "result":"N"
                        },
                        {
                            "itemCode":"2.4",
                            "result":"Y"
                        },
                        {
                            "itemCode":"2.5",
                        }
                    ]
                },
                {
                    "section":"03",
                    "items":[
                        {
                            "itemCode":"3.1"
                        },
                        {
                            "itemCode":"3.2"
                        },
                        {
                            "itemCode":"3.3"
                        },
                        {
                            "itemCode":"3.4"
                        },
                        {
                            "itemCode":"3.5"
                        },
                        {
                            "itemCode":"3.6",
                            "result":"Y"
                        },
                        {
                            "itemCode":"3.7",
                            "result":"Y"
                        },
                        {
                            "itemCode":"3.8",
                            "result":"Y"
                        },
                        {
                            "itemCode":"3.9",
                            "result":"Y"
                        },
                        {
                            "itemCode":"3.10",
                            "result":"Y"
                        },
                        {
                            "itemCode":"3.11",
                            "result":"Y"
                        },
                        {
                            "itemCode":"3.12",
                            "result":"Y"
                        },
                        {
                            "itemCode":"3.13",
                            "result":"Y"
                        },
                        {
                            "itemCode":"3.14"
                        }
                    ]
                },
                {
                    "section":"04",
                    "items":[
                        {
                            "itemCode":"4.1"
                        },
                        {
                            "itemCode":"4.2"
                        },
                        {
                            "itemCode":"4.3"
                        },
                        {
                            "itemCode":"4.4"
                        },
                        {
                            "itemCode":"4.5"
                        },
                        {
                            "itemCode":"4.6"
                        },
                        {
                            "itemCode":"4.7"
                        },
                        {
                            "itemCode":"4.8"
                        },
                        {
                            "itemCode":"4.9"
                        },
                        {
                            "itemCode":"4.10"
                        },
                        {
                            "itemCode":"4.11"
                        },
                        {
                            "itemCode":"4.12"
                        },
                        {
                            "itemCode":"4.13"
                        },
                        {
                            "itemCode":"4.14"
                        },
                        {
                            "itemCode":"4.15"
                        },
                        {
                            "itemCode":"4.16"
                        },
                        {
                            "itemCode":"4.17"
                        },
                    ]
                },
                {
                    "section":"05",
                    "items":[
                        {
                            "itemCode":"5.1"
                        },
                        {
                            "itemCode":"5.2"
                        },
                        {
                            "itemCode":"5.3"
                        },
                        {
                            "itemCode":"5.4"
                        },
                        {
                            "itemCode":"5.5"
                        },
                        {
                            "itemCode":"5.6"
                        },
                        {
                            "itemCode":"5.7"
                        },
                        {
                            "itemCode":"5.8"
                        },
                        {
                            "itemCode":"5.9"
                        },
                        {
                            "itemCode":"5.10"
                        },
                    ]
                },
                {
                    "section":"06",
                    "items":[
                        {
                            "itemCode":"6.1"
                        },
                        {
                            "itemCode":"6.2"
                        },
                        {
                            "itemCode":"6.3"
                        },
                        {
                            "itemCode":"6.4"
                        },
                        {
                            "itemCode":"6.5"
                        },
                        {
                            "itemCode":"6.6"
                        },
                        {
                            "itemCode":"6.7"
                        },
                        {
                            "itemCode":"6.8"
                        },
                        {
                            "itemCode":"6.9"
                        },
                        {
                            "itemCode":"6.10"
                        },
                        {
                            "itemCode":"6.11"
                        },
                        {
                            "itemCode":"6.12"
                        },
                        {
                            "itemCode":"6.13"
                        },
                        {
                            "itemCode":"6.14"
                        },
                        {
                            "itemCode":"6.15"
                        },
                        {
                            "itemCode":"6.16"
                        },
                        {
                            "itemCode":"6.17"
                        },
                        {
                            "itemCode":"6.18"
                        },
                        {
                            "itemCode":"6.19"
                        },
                        {
                            "itemCode":"6.20"
                        },
                    ]
                },
                {
                    "section":"07",
                    "items":[
                        {
                            "itemCode":"7.1"
                        },
                        {
                            "itemCode":"7.2"
                        },
                        {
                            "itemCode":"7.3"
                        },
                        {
                            "itemCode":"7.4"
                        },
                        {
                            "itemCode":"7.5"
                        },
                        {
                            "itemCode":"7.6"
                        },
                        {
                            "itemCode":"7.7"
                        },
                        {
                            "itemCode":"7.8"
                        },
                        {
                            "itemCode":"7.9"
                        }
                    ]
                },
                {
                    "section":"08",
                    "items":[
                        {
                            "itemCode":"8.1"
                        },
                        {
                            "itemCode":"8.2"
                        },
                        {
                            "itemCode":"8.3"
                        },
                        {
                            "itemCode":"8.4"
                        },
                        {
                            "itemCode":"8.5"
                        },
                        {
                            "itemCode":"8.6"
                        },
                        {
                            "itemCode":"8.7"
                        },
                        {
                            "itemCode":"8.8"
                        },
                        {
                            "itemCode":"8.9"
                        },
                        {
                            "itemCode":"8.10"
                        },
                        {
                            "itemCode":"8.11"
                        },
                        {
                            "itemCode":"8.12"
                        },
                        {
                            "itemCode":"8.13"
                        },
                        {
                            "itemCode":"8.14"
                        },
                        {
                            "itemCode":"8.15"
                        },
                        {
                            "itemCode":"8.16"
                        },
                        {
                            "itemCode":"8.17"
                        }
                    ]
                },
                {
                    "section":"09",
                    "items":[
                        {
                            "itemCode":"9.1"
                        },
                        {
                            "itemCode":"9.2"
                        },
                        {
                            "itemCode":"9.3"
                        },
                    ]
                }
            ]
        }
    },
    {
        "id": "4",
        "appNo": "A21090112",
        "appType": "followUp",
        "customerNo": "1201",
        "customerName": "黑松股份有限公司",
        "assessmentPlace": "屏東廠",
        "decision": "approve",
        "inspectionDate": "2022-01-05T00:00:00.000Z",
        "suggestions": [
            {"suggestion": "建議事項1.............................."},
            {"suggestion": "建議事項2.............................."}
        ],
        "notices": [
            {"notice": "注意事項1..............................."},
            {"notice": "注意事項2..............................."},
            {"notice": "注意事項3..............................."}
        ],
        "inspectionContent":{
            "standard":"leezen",
            "inspectionItems":[
                {"productionLine":"line1", "products":["Natural Benefits 食安生技-椰子汁"]},
                {"productionLine":"line2", "products":["杏仁玄米餅","核桃酥"]}
            ],
            "inspectionScope":"評鑑產品之評鑑場所場區環境與衛生管理、製程與品質管制、原料查驗、相關檢驗報告與紀錄表單核對等，及前次所列查驗重點之執行狀況確認"
        },
        "inspectionResult":{
            "previousNcrs":[
                {
                    "appNo":"A20080111",
                    "type":"secondary",
                    "inspectionItem":"03-3",
                    "observationDesc":"碳酸鈣550g/包,未涵蓋使用範圍"
                },
                {
                    "appNo":"A20080111",
                    "type":"secondary",
                    "inspectionItem":"06-1",
                    "observationDesc":"評鑑產品之評鑑場所場區環境與衛生管理、製程與品質管制"
                }
            ],
            "productChangeInspectionKeyNote":"1.員工衛生新進食品從業人員應先經醫療機構健康檢查合格後，始得聘僱；雇主每年應主動辦理健康檢查至少一次。\n" +
                "2.員工教育訓練：新進食品從業人員應接受適當之教育訓練，使其執行能力符合生產、衛生及品質管理之要求；在職從業人員，應定期接受食品安全、衛生及品質管理之教育訓練，並作成紀錄。",
            "leezenRawMaterials":[
                {
                    "id":"1",
                    "type":"material",
                    "name":"豆蓉粉(新版)",
                    "storageCondition":"roomTemperature",
                    "composition":"水、非基因改造脫脂黃豆片、小麥、食鹽、轉化液糖(蔗糖、水)、調味劑(DL-蘋果酸)",
                    "domesticVendor":"穎昌食品有限公司(新和美)",
                    "importer":"",
                    "manufacturer":"穎昌食品有限公司(新和美)",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "addRatio":9,
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":1,
                    "validityAndSituation":"有效日期：2022/03/19(此批非里仁使用)",
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"2",
                    "type":"material",
                    "name":"美國加州杏仁果",
                    "storageCondition":"roomTemperature",
                    "composition":"樹薯澱粉、水(原料)",
                    "domesticVendor":"信成股份有限公司",
                    "importer":"信成股份有限公司",
                    "manufacturer":"TERRA NOVA TRADING INC.",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":2,
                    "validityAndSituation":"有效日期：2023/04/18",
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"3",
                    "name":"美國加州杏仁果",
                    "storageCondition":"refrigeration",
                    "composition":"植物油脂(菜籽油)、洋蔥、葡萄糖、抗氧化劑(維生素C、混合濃縮生育醇)",
                    "domesticVendor":"爾邦得有限公司",
                    "importer":"爾邦得有限公司",
                    "manufacturer":"TERRA NOVA TRADING INC.",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":3,
                    "validityAndSituation":"槽車運送日期2021/09/14(保存期限3個月)，平均約1個月左右進貨一次，\n" +
                        "當天使用有效日期2021.11.17(8/17進貨)",
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"4",
                    "name":"美國加州杏仁果",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"信和股份有限公司",
                    "importer":"信和股份有限公司",
                    "manufacturer":"RPAC,LLC",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":4,
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"5",
                    "name":"美國加州杏仁果",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"信和股份有限公司",
                    "importer":"信和股份有限公司",
                    "manufacturer":"VANN FAMLLY ORCHARDS",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":5,
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"6",
                    "name":"甜扁桃仁粒",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"成久旺股份有限公司",
                    "importer":"成久旺股份有限公司",
                    "manufacturer":"TWIN COMMODITIES,INC.",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":6,
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"7",
                    "name":"帶皮杏仁粒",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"昇祥股份有限公司",
                    "importer":"昇祥股份有限公司",
                    "manufacturer":"美國加州皮爾農場公司",
                    "originPlace":"美國加州",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":7,
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"8",
                    "name":"有機生糙米粉(台灣)",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"青田農產有限公司",
                    "importer":"",
                    "manufacturer":"青田農產有限公司",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":8,
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"9",
                    "name":"精製椰子油",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"禾發實業有限公司",
                    "importer":"禾發實業有限公司",
                    "manufacturer":"OLEO-FATS, INCORPORATED",
                    "originPlace":"菲律賓",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":9,
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"10",
                    "name":"杏仁細粉",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"迦得貿易實業有限公司",
                    "importer":"迦得貿易實業有限公司",
                    "manufacturer":"Treehouse California Almonds LLC",
                    "originPlace":"菲律賓",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":10,
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"11",
                    "name":"杏仁粉(細)",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"成久旺股份有限公司",
                    "importer":"成久旺股份有限公司",
                    "manufacturer":"Treehouse California Almonds LLC",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":11,
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"12",
                    "name":"混合濃縮生育醇",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"信意企業股份有限公司",
                    "importer":"信意企業股份有限公司",
                    "manufacturer":"CARGILL INCORPORATED",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"衛部添製字第002764號/TFAA1N002764004",
                    "processingAid":"N",
                    "accessory":"N",
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                }
            ],
            "tseyueRawMaterials":[
                {
                    "id":"1",
                    "type":"material",
                    "name":"玉米粉",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"乖乖",
                    "importer":"",
                    "manufacturer":"乖乖",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "addRatio":9,
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":1,
                    "validityAndSituation":"有效日期：2022/3/15",
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"2",
                    "type":"material",
                    "name":"精製特砂",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"台糖",
                    "manufacturer":"台糖",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":2,
                    "validityAndSituation":"有效日期：2023/04/18",
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"3",
                    "name":"二次精製軟棕油",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"福懋油脂",
                    "manufacturer":"福懋油脂",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":3,
                    "validityAndSituation":"有效日期：2023/07/09",
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                }
            ]
        },
        "summaryReport":[
            {
                "carNo":"INS01-01",
                "ncrType":"primary",
                "checkItems":["02-1","04-2"],
                "observation":"廠外環境污染源現況與申請資料描述不一致",
                "nextInspectionFocus":true,
                "reviewResult":"correct",
                "reviewersOpinions":[
                    {
                        "reviewer":"王小明",
                        "nextInspectionFocus":true,
                        "reviewResult":"correct",
                        "comment":"Gurman 並且稱該頭戴裝置「最快 2022」年可以到來，而且未來蘋果也會推出「單純 AR」的機種，但那要再多等幾年才會來臨了"
                    },
                    {
                        "reviewer":"王大同",
                        "nextInspectionFocus":true,
                        "reviewResult":"correct",
                        "comment":"眾人在期待的，更多還是蘋果能不能利用其格外強大的產品開發與行銷能力，將 MR 帶進主流"
                    }
                ],
                "correctionActionPlan":"修正校驗範圍，使其涵蓋量測範圍",
                "estimatedImprovementDate":"2021-07-31T08:20:10.000Z",
                "evaluateCorrectiveAction":"agree",
                "evaluationContent":"確認已修改完成",
                "correctionHistories":[
                    {"replyDate":"2021-09-18T08:20:10.000","correctionActionPlan":"規劃加強清潔次數","estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-19T08:20:10.000","evaluationContent":"請提供具體計畫內容"},
                    {"replyDate":"2021-09-21T08:20:10.000","correctionActionPlan":"規劃每週清潔次數由1次改成2次", "estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-22T08:20:10.000","evaluationContent":"請說明預計開始實施日期"}
                ],
            },
            {
                "carNo":"INS01-02",
                "ncrType":"secondary",
                "checkItems":["03-1"],
                "observation":"客戶提供之評鑑場所平面圖與實際看到者不一致",
                "nextInspectionFocus":true,
                "reviewResult":"track",
                "reviewersOpinions":[
                    {
                        "reviewer":"王小明",
                        "nextInspectionFocus":true,
                        "reviewResult":"track",
                        "comment":"Gurman 並且稱該頭戴裝置「最快 2022」年可以到來，而且未來蘋果也會推出「單純 AR」的機種，但那要再多等幾年才會來臨了"
                    },
                    {
                        "reviewer":"王大同",
                        "nextInspectionFocus":true,
                        "reviewResult":"track",
                        "comment":"眾人在期待的，更多還是蘋果能不能利用其格外強大的產品開發與行銷能力，將 MR 帶進主流"
                    }
                ],
                "correctionActionPlan":"修正校驗範圍，使其涵蓋量測範圍",
                "estimatedImprovementDate":"2021-07-31T08:20:10.000Z",
                "evaluateCorrectiveAction":"agree",
                "evaluationContent":"確認已修改完成",
                "correctionHistories":[
                    {"replyDate":"2021-09-18T08:20:10.000","correctionActionPlan":"規劃加強清潔次數","estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-19T08:20:10.000","evaluationContent":"請提供具體計畫內容"},
                    {"replyDate":"2021-09-21T08:20:10.000","correctionActionPlan":"規劃每週清潔次數由1次改成2次", "estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-22T08:20:10.000","evaluationContent":"請說明預計開始實施日期"}
                ],
            },
            {
                "carNo":"INS01-03",
                "ncrType":"secondary",
                "checkItems":["06-1","06-2"],
                "observation":"原料相關證明文件或檢驗報告可與使用原料來源沒有勾稽",
                "reviewersOpinions":[
                    {
                        "reviewer":"王小明",
                        "nextInspectionFocus":true,
                        "reviewResult":"track",
                        "comment":"Gurman 並且稱該頭戴裝置「最快 2022」年可以到來，而且未來蘋果也會推出「單純 AR」的機種，但那要再多等幾年才會來臨了"
                    },
                    {
                        "reviewer":"王大同",
                        "reviewResult":"correct",
                        "comment":"眾人在期待的，更多還是蘋果能不能利用其格外強大的產品開發與行銷能力，將 MR 帶進主流"
                    }
                ],
                "correctionActionPlan":"修正校驗範圍，使其涵蓋量測範圍",
                "estimatedImprovementDate":"2021-07-31T08:20:10.000Z",
                "evaluateCorrectiveAction":"agree",
                "evaluationContent":"確認已修改完成",
                "correctionHistories":[
                    {"replyDate":"2021-09-18T08:20:10.000","correctionActionPlan":"規劃加強清潔次數","estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-19T08:20:10.000","evaluationContent":"請提供具體計畫內容"},
                    {"replyDate":"2021-09-21T08:20:10.000","correctionActionPlan":"規劃每週清潔次數由1次改成2次", "estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-22T08:20:10.000","evaluationContent":"請說明預計開始實施日期"}
                ],
            },
            {
                "carNo":"INS01-04",
                "checkItems":["06-3"],
                "ncrType":"secondary",
                "observation":"原材料進貨時沒有驗收紀錄",
                "nextInspectionFocus":true,
                "reviewResult":"track",
                "reviewersOpinions":[
                    {
                        "reviewer":"王小明",
                        "nextInspectionFocus":true,
                        "reviewResult":"track",
                        "comment":"Gurman 並且稱該頭戴裝置「最快 2022」年可以到來，而且未來蘋果也會推出「單純 AR」的機種，但那要再多等幾年才會來臨了"
                    },
                ],
                "correctionActionPlan":"修正校驗範圍，使其涵蓋量測範圍",
                "estimatedImprovementDate":"2021-07-31T08:20:10.000Z",
                "evaluateCorrectiveAction":"agree",
                "evaluationContent":"確認已修改完成",
                "correctionHistories":[
                    {"replyDate":"2021-09-18T08:20:10.000","correctionActionPlan":"規劃加強清潔次數","estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-19T08:20:10.000","evaluationContent":"請提供具體計畫內容"},
                    {"replyDate":"2021-09-21T08:20:10.000","correctionActionPlan":"規劃每週清潔次數由1次改成2次", "estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-22T08:20:10.000","evaluationContent":"請說明預計開始實施日期"}
                ],
            }
        ],
        "inspectionItemInfo":{
            "inspectionDates":[
                {"inspectionDate":"2021-09-13T16:00:00.000Z",
                    "arrivalTime": "2021-09-13T16:00:00.000Z",
                    "departureTime": "2021-09-13T16:00:00.000Z",
                    "inspectors":[
                        {"inspector":"王大同", "role":"lead"},
                        {"inspector":"張小明", "role":"inspector"},
                        {"inspector":"林小花", "role":"observer"}
                    ],
                    "weather": "sunny",
                },
                {"inspectionDate":"2021-09-15T16:00:00.000Z",
                    "arrivalTime": "2021-09-13T16:00:00.000Z",
                    "departureTime": "2021-09-13T16:00:00.000Z",
                    "inspectors":[
                        {"inspector":"吳小保", "role":"inspector"},
                        {"inspector":"林小花", "role":"observer"}
                    ],
                    "weather": "rainy",
                }
            ],
            "inspector":{
                "lead":"王大同",
                "inspector":["張小明","吳小保"],
                "observer":["林小花"]
            },
            "inspectionItems":[
                {
                    "section":"01",
                    "items":[
                        {
                            "itemCode":"1.1",
                            "result":"Y"
                        },
                        {
                            "itemCode":"1.2",
                            "result":"Y"
                        },
                        {
                            "itemCode":"1.3",
                            "ncrType":"secondary",
                            "result":"N",
                            "observation":"沒有持續全程在場"
                        },
                        {
                            "itemCode":"1.4",
                            "ncrType":"observation",
                            "result":"N",
                            "observation":"標籤微破損"
                        },
                        {
                            "itemCode":"1.5",
                            "result":"Y"
                        }
                    ]
                },
                {
                    "section":"02",
                    "items":[
                        {
                            "itemCode":"2.1",
                            "result":"Y"
                        },
                        {
                            "itemCode":"2.2",
                            "result":"Y"
                        },
                        {
                            "itemCode":"2.3",
                            "ncrType":"secondary",
                            "result":"N"
                        },
                        {
                            "itemCode":"2.4",
                            "result":"Y"
                        },
                        {
                            "itemCode":"2.5",
                        }
                    ]
                },
                {
                    "section":"03",
                    "items":[
                        {
                            "itemCode":"3.1"
                        },
                        {
                            "itemCode":"3.2"
                        },
                        {
                            "itemCode":"3.3"
                        },
                        {
                            "itemCode":"3.4"
                        },
                        {
                            "itemCode":"3.5"
                        },
                        {
                            "itemCode":"3.6",
                            "result":"Y"
                        },
                        {
                            "itemCode":"3.7",
                            "result":"Y"
                        },
                        {
                            "itemCode":"3.8",
                            "result":"Y"
                        },
                        {
                            "itemCode":"3.9",
                            "result":"Y"
                        },
                        {
                            "itemCode":"3.10",
                            "result":"Y"
                        },
                        {
                            "itemCode":"3.11",
                            "result":"Y"
                        },
                        {
                            "itemCode":"3.12",
                            "result":"Y"
                        },
                        {
                            "itemCode":"3.13",
                            "result":"Y"
                        },
                        {
                            "itemCode":"3.14"
                        }
                    ]
                },
                {
                    "section":"04",
                    "items":[
                        {
                            "itemCode":"4.1"
                        },
                        {
                            "itemCode":"4.2"
                        },
                        {
                            "itemCode":"4.3"
                        },
                        {
                            "itemCode":"4.4"
                        },
                        {
                            "itemCode":"4.5"
                        },
                        {
                            "itemCode":"4.6"
                        },
                        {
                            "itemCode":"4.7"
                        },
                        {
                            "itemCode":"4.8"
                        },
                        {
                            "itemCode":"4.9"
                        },
                        {
                            "itemCode":"4.10"
                        },
                        {
                            "itemCode":"4.11"
                        },
                        {
                            "itemCode":"4.12"
                        },
                        {
                            "itemCode":"4.13"
                        },
                        {
                            "itemCode":"4.14"
                        },
                        {
                            "itemCode":"4.15"
                        },
                        {
                            "itemCode":"4.16"
                        },
                        {
                            "itemCode":"4.17"
                        },
                    ]
                },
                {
                    "section":"05",
                    "items":[
                        {
                            "itemCode":"5.1"
                        },
                        {
                            "itemCode":"5.2"
                        },
                        {
                            "itemCode":"5.3"
                        },
                        {
                            "itemCode":"5.4"
                        },
                        {
                            "itemCode":"5.5"
                        },
                        {
                            "itemCode":"5.6"
                        },
                        {
                            "itemCode":"5.7"
                        },
                        {
                            "itemCode":"5.8"
                        },
                        {
                            "itemCode":"5.9"
                        },
                        {
                            "itemCode":"5.10"
                        },
                    ]
                },
                {
                    "section":"06",
                    "items":[
                        {
                            "itemCode":"6.1"
                        },
                        {
                            "itemCode":"6.2"
                        },
                        {
                            "itemCode":"6.3"
                        },
                        {
                            "itemCode":"6.4"
                        },
                        {
                            "itemCode":"6.5"
                        },
                        {
                            "itemCode":"6.6"
                        },
                        {
                            "itemCode":"6.7"
                        },
                        {
                            "itemCode":"6.8"
                        },
                        {
                            "itemCode":"6.9"
                        },
                        {
                            "itemCode":"6.10"
                        },
                        {
                            "itemCode":"6.11"
                        },
                        {
                            "itemCode":"6.12"
                        },
                        {
                            "itemCode":"6.13"
                        },
                        {
                            "itemCode":"6.14"
                        },
                        {
                            "itemCode":"6.15"
                        },
                        {
                            "itemCode":"6.16"
                        },
                        {
                            "itemCode":"6.17"
                        },
                        {
                            "itemCode":"6.18"
                        },
                        {
                            "itemCode":"6.19"
                        },
                        {
                            "itemCode":"6.20"
                        },
                    ]
                },
                {
                    "section":"07",
                    "items":[
                        {
                            "itemCode":"7.1"
                        },
                        {
                            "itemCode":"7.2"
                        },
                        {
                            "itemCode":"7.3"
                        },
                        {
                            "itemCode":"7.4"
                        },
                        {
                            "itemCode":"7.5"
                        },
                        {
                            "itemCode":"7.6"
                        },
                        {
                            "itemCode":"7.7"
                        },
                        {
                            "itemCode":"7.8"
                        },
                        {
                            "itemCode":"7.9"
                        }
                    ]
                },
                {
                    "section":"08",
                    "items":[
                        {
                            "itemCode":"8.1"
                        },
                        {
                            "itemCode":"8.2"
                        },
                        {
                            "itemCode":"8.3"
                        },
                        {
                            "itemCode":"8.4"
                        },
                        {
                            "itemCode":"8.5"
                        },
                        {
                            "itemCode":"8.6"
                        },
                        {
                            "itemCode":"8.7"
                        },
                        {
                            "itemCode":"8.8"
                        },
                        {
                            "itemCode":"8.9"
                        },
                        {
                            "itemCode":"8.10"
                        },
                        {
                            "itemCode":"8.11"
                        },
                        {
                            "itemCode":"8.12"
                        },
                        {
                            "itemCode":"8.13"
                        },
                        {
                            "itemCode":"8.14"
                        },
                        {
                            "itemCode":"8.15"
                        },
                        {
                            "itemCode":"8.16"
                        },
                        {
                            "itemCode":"8.17"
                        }
                    ]
                },
                {
                    "section":"09",
                    "items":[
                        {
                            "itemCode":"9.1"
                        },
                        {
                            "itemCode":"9.2"
                        },
                        {
                            "itemCode":"9.3"
                        },
                    ]
                }
            ]
        }
    },
    {
        "id": "5",
        "appNo": "A21091102",
        "appType": "initial",
        "customerNo": "0054",
        "customerName": "我的輕食有限公司",
        "assessmentPlace": "台東廠",
        "decision": "approve",
        "inspectionDate": "2022-01-05T00:00:00.000Z",
        "suggestions": [
            {"suggestion": "建議事項1.............................."},
            {"suggestion": "建議事項2.............................."}
        ],
        "notices": [
            {"notice": "注意事項1..............................."},
            {"notice": "注意事項2..............................."},
            {"notice": "注意事項3..............................."}
        ],
        "inspectionContent":{
            "standard":"leezen",
            "inspectionItems":[
                {"productionLine":"line1", "products":["Natural Benefits 食安生技-椰子汁"]},
                {"productionLine":"line2", "products":["杏仁玄米餅","核桃酥"]}
            ],
            "inspectionScope":"評鑑產品之評鑑場所場區環境與衛生管理、製程與品質管制、原料查驗、相關檢驗報告與紀錄表單核對等，及前次所列查驗重點之執行狀況確認"
        },
        "inspectionResult":{
            "previousNcrs":[
                {
                    "appNo":"A20080111",
                    "type":"secondary",
                    "inspectionItem":"03-3",
                    "observationDesc":"碳酸鈣550g/包,未涵蓋使用範圍"
                },
                {
                    "appNo":"A20080111",
                    "type":"secondary",
                    "inspectionItem":"06-1",
                    "observationDesc":"評鑑產品之評鑑場所場區環境與衛生管理、製程與品質管制"
                }
            ],
            "productChangeInspectionKeyNote":"1.員工衛生新進食品從業人員應先經醫療機構健康檢查合格後，始得聘僱；雇主每年應主動辦理健康檢查至少一次。\n" +
                "2.員工教育訓練：新進食品從業人員應接受適當之教育訓練，使其執行能力符合生產、衛生及品質管理之要求；在職從業人員，應定期接受食品安全、衛生及品質管理之教育訓練，並作成紀錄。",
            "leezenRawMaterials":[
                {
                    "id":"1",
                    "type":"material",
                    "name":"豆蓉粉(新版)",
                    "storageCondition":"roomTemperature",
                    "composition":"水、非基因改造脫脂黃豆片、小麥、食鹽、轉化液糖(蔗糖、水)、調味劑(DL-蘋果酸)",
                    "domesticVendor":"穎昌食品有限公司(新和美)",
                    "importer":"",
                    "manufacturer":"穎昌食品有限公司(新和美)",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "addRatio":9,
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":1,
                    "validityAndSituation":"有效日期：2022/03/19(此批非里仁使用)",
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"2",
                    "type":"material",
                    "name":"美國加州杏仁果",
                    "storageCondition":"roomTemperature",
                    "composition":"樹薯澱粉、水(原料)",
                    "domesticVendor":"信成股份有限公司",
                    "importer":"信成股份有限公司",
                    "manufacturer":"TERRA NOVA TRADING INC.",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":2,
                    "validityAndSituation":"有效日期：2023/04/18",
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"3",
                    "name":"美國加州杏仁果",
                    "storageCondition":"refrigeration",
                    "composition":"植物油脂(菜籽油)、洋蔥、葡萄糖、抗氧化劑(維生素C、混合濃縮生育醇)",
                    "domesticVendor":"爾邦得有限公司",
                    "importer":"爾邦得有限公司",
                    "manufacturer":"TERRA NOVA TRADING INC.",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":3,
                    "validityAndSituation":"槽車運送日期2021/09/14(保存期限3個月)，平均約1個月左右進貨一次，\n" +
                        "當天使用有效日期2021.11.17(8/17進貨)",
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"4",
                    "name":"美國加州杏仁果",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"信和股份有限公司",
                    "importer":"信和股份有限公司",
                    "manufacturer":"RPAC,LLC",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":4,
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"5",
                    "name":"美國加州杏仁果",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"信和股份有限公司",
                    "importer":"信和股份有限公司",
                    "manufacturer":"VANN FAMLLY ORCHARDS",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":5,
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"6",
                    "name":"甜扁桃仁粒",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"成久旺股份有限公司",
                    "importer":"成久旺股份有限公司",
                    "manufacturer":"TWIN COMMODITIES,INC.",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":6,
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"7",
                    "name":"帶皮杏仁粒",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"昇祥股份有限公司",
                    "importer":"昇祥股份有限公司",
                    "manufacturer":"美國加州皮爾農場公司",
                    "originPlace":"美國加州",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":7,
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"8",
                    "name":"有機生糙米粉(台灣)",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"青田農產有限公司",
                    "importer":"",
                    "manufacturer":"青田農產有限公司",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":8,
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"9",
                    "name":"精製椰子油",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"禾發實業有限公司",
                    "importer":"禾發實業有限公司",
                    "manufacturer":"OLEO-FATS, INCORPORATED",
                    "originPlace":"菲律賓",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":9,
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"10",
                    "name":"杏仁細粉",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"迦得貿易實業有限公司",
                    "importer":"迦得貿易實業有限公司",
                    "manufacturer":"Treehouse California Almonds LLC",
                    "originPlace":"菲律賓",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":10,
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"11",
                    "name":"杏仁粉(細)",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"成久旺股份有限公司",
                    "importer":"成久旺股份有限公司",
                    "manufacturer":"Treehouse California Almonds LLC",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":11,
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"12",
                    "name":"混合濃縮生育醇",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"信意企業股份有限公司",
                    "importer":"信意企業股份有限公司",
                    "manufacturer":"CARGILL INCORPORATED",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"衛部添製字第002764號/TFAA1N002764004",
                    "processingAid":"N",
                    "accessory":"N",
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                }
            ],
            "tseyueRawMaterials":[
                {
                    "id":"1",
                    "type":"material",
                    "name":"玉米粉",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"乖乖",
                    "importer":"",
                    "manufacturer":"乖乖",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "addRatio":9,
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":1,
                    "validityAndSituation":"有效日期：2022/3/15",
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"2",
                    "type":"material",
                    "name":"精製特砂",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"台糖",
                    "manufacturer":"台糖",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":2,
                    "validityAndSituation":"有效日期：2023/04/18",
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                },
                {
                    "id":"3",
                    "name":"二次精製軟棕油",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"福懋油脂",
                    "manufacturer":"福懋油脂",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":3,
                    "validityAndSituation":"有效日期：2023/07/09",
                    "productNames":["杏仁玄米餅", "核桃酥"],
                    "verify": "compliance",
                }
            ]
        },
        "summaryReport":[
            {
                "carNo":"INS01-01",
                "ncrType":"primary",
                "checkItems":["02-1","04-2"],
                "observation":"廠外環境污染源現況與申請資料描述不一致",
                "nextInspectionFocus":true,
                "reviewResult":"correct",
                "reviewersOpinions":[
                    {
                        "reviewer":"王小明",
                        "nextInspectionFocus":true,
                        "reviewResult":"correct",
                        "comment":"Gurman 並且稱該頭戴裝置「最快 2022」年可以到來，而且未來蘋果也會推出「單純 AR」的機種，但那要再多等幾年才會來臨了"
                    },
                    {
                        "reviewer":"王大同",
                        "nextInspectionFocus":true,
                        "reviewResult":"correct",
                        "comment":"眾人在期待的，更多還是蘋果能不能利用其格外強大的產品開發與行銷能力，將 MR 帶進主流"
                    }
                ],
                "correctionActionPlan":"修正校驗範圍，使其涵蓋量測範圍",
                "estimatedImprovementDate":"2021-07-31T08:20:10.000Z",
                "evaluateCorrectiveAction":"agree",
                "evaluationContent":"確認已修改完成",
                "correctionHistories":[
                    {"replyDate":"2021-09-18T08:20:10.000","correctionActionPlan":"規劃加強清潔次數","estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-19T08:20:10.000","evaluationContent":"請提供具體計畫內容"},
                    {"replyDate":"2021-09-21T08:20:10.000","correctionActionPlan":"規劃每週清潔次數由1次改成2次", "estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-22T08:20:10.000","evaluationContent":"請說明預計開始實施日期"}
                ],
            },
            {
                "carNo":"INS01-02",
                "ncrType":"secondary",
                "checkItems":["03-1"],
                "observation":"客戶提供之評鑑場所平面圖與實際看到者不一致",
                "nextInspectionFocus":true,
                "reviewResult":"track",
                "reviewersOpinions":[
                    {
                        "reviewer":"王小明",
                        "nextInspectionFocus":true,
                        "reviewResult":"track",
                        "comment":"Gurman 並且稱該頭戴裝置「最快 2022」年可以到來，而且未來蘋果也會推出「單純 AR」的機種，但那要再多等幾年才會來臨了"
                    },
                    {
                        "reviewer":"王大同",
                        "nextInspectionFocus":true,
                        "reviewResult":"track",
                        "comment":"眾人在期待的，更多還是蘋果能不能利用其格外強大的產品開發與行銷能力，將 MR 帶進主流"
                    }
                ],
                "correctionActionPlan":"修正校驗範圍，使其涵蓋量測範圍",
                "estimatedImprovementDate":"2021-07-31T08:20:10.000Z",
                "evaluateCorrectiveAction":"agree",
                "evaluationContent":"確認已修改完成",
                "correctionHistories":[
                    {"replyDate":"2021-09-18T08:20:10.000","correctionActionPlan":"規劃加強清潔次數","estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-19T08:20:10.000","evaluationContent":"請提供具體計畫內容"},
                    {"replyDate":"2021-09-21T08:20:10.000","correctionActionPlan":"規劃每週清潔次數由1次改成2次", "estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-22T08:20:10.000","evaluationContent":"請說明預計開始實施日期"}
                ],
            },
            {
                "carNo":"INS01-03",
                "ncrType":"secondary",
                "checkItems":["06-1","06-2"],
                "observation":"原料相關證明文件或檢驗報告可與使用原料來源沒有勾稽",
                "reviewersOpinions":[
                    {
                        "reviewer":"王小明",
                        "nextInspectionFocus":true,
                        "reviewResult":"track",
                        "comment":"Gurman 並且稱該頭戴裝置「最快 2022」年可以到來，而且未來蘋果也會推出「單純 AR」的機種，但那要再多等幾年才會來臨了"
                    },
                    {
                        "reviewer":"王大同",
                        "reviewResult":"correct",
                        "comment":"眾人在期待的，更多還是蘋果能不能利用其格外強大的產品開發與行銷能力，將 MR 帶進主流"
                    }
                ],
                "correctionActionPlan":"修正校驗範圍，使其涵蓋量測範圍",
                "estimatedImprovementDate":"2021-07-31T08:20:10.000Z",
                "evaluateCorrectiveAction":"agree",
                "evaluationContent":"確認已修改完成",
                "correctionHistories":[
                    {"replyDate":"2021-09-18T08:20:10.000","correctionActionPlan":"規劃加強清潔次數","estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-19T08:20:10.000","evaluationContent":"請提供具體計畫內容"},
                    {"replyDate":"2021-09-21T08:20:10.000","correctionActionPlan":"規劃每週清潔次數由1次改成2次", "estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-22T08:20:10.000","evaluationContent":"請說明預計開始實施日期"}
                ],
            },
            {
                "carNo":"INS01-04",
                "checkItems":["06-3"],
                "ncrType":"secondary",
                "observation":"原材料進貨時沒有驗收紀錄",
                "nextInspectionFocus":true,
                "reviewResult":"track",
                "reviewersOpinions":[
                    {
                        "reviewer":"王小明",
                        "nextInspectionFocus":true,
                        "reviewResult":"track",
                        "comment":"Gurman 並且稱該頭戴裝置「最快 2022」年可以到來，而且未來蘋果也會推出「單純 AR」的機種，但那要再多等幾年才會來臨了"
                    },
                ],
                "correctionActionPlan":"修正校驗範圍，使其涵蓋量測範圍",
                "estimatedImprovementDate":"2021-07-31T08:20:10.000Z",
                "evaluateCorrectiveAction":"agree",
                "evaluationContent":"確認已修改完成",
                "correctionHistories":[
                    {"replyDate":"2021-09-18T08:20:10.000","correctionActionPlan":"規劃加強清潔次數","estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-19T08:20:10.000","evaluationContent":"請提供具體計畫內容"},
                    {"replyDate":"2021-09-21T08:20:10.000","correctionActionPlan":"規劃每週清潔次數由1次改成2次", "estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-22T08:20:10.000","evaluationContent":"請說明預計開始實施日期"}
                ],
            }
        ],
        "inspectionItemInfo":{
            "inspectionDates":[
                {"inspectionDate":"2021-09-13T16:00:00.000Z",
                    "arrivalTime": "2021-09-13T16:00:00.000Z",
                    "departureTime": "2021-09-13T16:00:00.000Z",
                    "inspectors":[
                        {"inspector":"王大同", "role":"lead"},
                        {"inspector":"張小明", "role":"inspector"},
                        {"inspector":"林小花", "role":"observer"}
                    ],
                    "weather": "sunny",
                },
                {"inspectionDate":"2021-09-15T16:00:00.000Z",
                    "arrivalTime": "2021-09-13T16:00:00.000Z",
                    "departureTime": "2021-09-13T16:00:00.000Z",
                    "inspectors":[
                        {"inspector":"吳小保", "role":"inspector"},
                        {"inspector":"林小花", "role":"observer"}
                    ],
                    "weather": "rainy",
                }
            ],
            "inspector":{
                "lead":"王大同",
                "inspector":["張小明","吳小保"],
                "observer":["林小花"]
            },
            "inspectionItems":[
                {
                    "section":"01",
                    "items":[
                        {
                            "itemCode":"1.1",
                            "result":"Y"
                        },
                        {
                            "itemCode":"1.2",
                            "result":"Y"
                        },
                        {
                            "itemCode":"1.3",
                            "ncrType":"secondary",
                            "result":"N",
                            "observation":"沒有持續全程在場"
                        },
                        {
                            "itemCode":"1.4",
                            "ncrType":"observation",
                            "result":"N",
                            "observation":"標籤微破損"
                        },
                        {
                            "itemCode":"1.5",
                            "result":"Y"
                        }
                    ]
                },
                {
                    "section":"02",
                    "items":[
                        {
                            "itemCode":"2.1",
                            "result":"Y"
                        },
                        {
                            "itemCode":"2.2",
                            "result":"Y"
                        },
                        {
                            "itemCode":"2.3",
                            "ncrType":"secondary",
                            "result":"N"
                        },
                        {
                            "itemCode":"2.4",
                            "result":"Y"
                        },
                        {
                            "itemCode":"2.5",
                        }
                    ]
                },
                {
                    "section":"03",
                    "items":[
                        {
                            "itemCode":"3.1"
                        },
                        {
                            "itemCode":"3.2"
                        },
                        {
                            "itemCode":"3.3"
                        },
                        {
                            "itemCode":"3.4"
                        },
                        {
                            "itemCode":"3.5"
                        },
                        {
                            "itemCode":"3.6",
                            "result":"Y"
                        },
                        {
                            "itemCode":"3.7",
                            "result":"Y"
                        },
                        {
                            "itemCode":"3.8",
                            "result":"Y"
                        },
                        {
                            "itemCode":"3.9",
                            "result":"Y"
                        },
                        {
                            "itemCode":"3.10",
                            "result":"Y"
                        },
                        {
                            "itemCode":"3.11",
                            "result":"Y"
                        },
                        {
                            "itemCode":"3.12",
                            "result":"Y"
                        },
                        {
                            "itemCode":"3.13",
                            "result":"Y"
                        },
                        {
                            "itemCode":"3.14"
                        }
                    ]
                },
                {
                    "section":"04",
                    "items":[
                        {
                            "itemCode":"4.1"
                        },
                        {
                            "itemCode":"4.2"
                        },
                        {
                            "itemCode":"4.3"
                        },
                        {
                            "itemCode":"4.4"
                        },
                        {
                            "itemCode":"4.5"
                        },
                        {
                            "itemCode":"4.6"
                        },
                        {
                            "itemCode":"4.7"
                        },
                        {
                            "itemCode":"4.8"
                        },
                        {
                            "itemCode":"4.9"
                        },
                        {
                            "itemCode":"4.10"
                        },
                        {
                            "itemCode":"4.11"
                        },
                        {
                            "itemCode":"4.12"
                        },
                        {
                            "itemCode":"4.13"
                        },
                        {
                            "itemCode":"4.14"
                        },
                        {
                            "itemCode":"4.15"
                        },
                        {
                            "itemCode":"4.16"
                        },
                        {
                            "itemCode":"4.17"
                        },
                    ]
                },
                {
                    "section":"05",
                    "items":[
                        {
                            "itemCode":"5.1"
                        },
                        {
                            "itemCode":"5.2"
                        },
                        {
                            "itemCode":"5.3"
                        },
                        {
                            "itemCode":"5.4"
                        },
                        {
                            "itemCode":"5.5"
                        },
                        {
                            "itemCode":"5.6"
                        },
                        {
                            "itemCode":"5.7"
                        },
                        {
                            "itemCode":"5.8"
                        },
                        {
                            "itemCode":"5.9"
                        },
                        {
                            "itemCode":"5.10"
                        },
                    ]
                },
                {
                    "section":"06",
                    "items":[
                        {
                            "itemCode":"6.1"
                        },
                        {
                            "itemCode":"6.2"
                        },
                        {
                            "itemCode":"6.3"
                        },
                        {
                            "itemCode":"6.4"
                        },
                        {
                            "itemCode":"6.5"
                        },
                        {
                            "itemCode":"6.6"
                        },
                        {
                            "itemCode":"6.7"
                        },
                        {
                            "itemCode":"6.8"
                        },
                        {
                            "itemCode":"6.9"
                        },
                        {
                            "itemCode":"6.10"
                        },
                        {
                            "itemCode":"6.11"
                        },
                        {
                            "itemCode":"6.12"
                        },
                        {
                            "itemCode":"6.13"
                        },
                        {
                            "itemCode":"6.14"
                        },
                        {
                            "itemCode":"6.15"
                        },
                        {
                            "itemCode":"6.16"
                        },
                        {
                            "itemCode":"6.17"
                        },
                        {
                            "itemCode":"6.18"
                        },
                        {
                            "itemCode":"6.19"
                        },
                        {
                            "itemCode":"6.20"
                        },
                    ]
                },
                {
                    "section":"07",
                    "items":[
                        {
                            "itemCode":"7.1"
                        },
                        {
                            "itemCode":"7.2"
                        },
                        {
                            "itemCode":"7.3"
                        },
                        {
                            "itemCode":"7.4"
                        },
                        {
                            "itemCode":"7.5"
                        },
                        {
                            "itemCode":"7.6"
                        },
                        {
                            "itemCode":"7.7"
                        },
                        {
                            "itemCode":"7.8"
                        },
                        {
                            "itemCode":"7.9"
                        }
                    ]
                },
                {
                    "section":"08",
                    "items":[
                        {
                            "itemCode":"8.1"
                        },
                        {
                            "itemCode":"8.2"
                        },
                        {
                            "itemCode":"8.3"
                        },
                        {
                            "itemCode":"8.4"
                        },
                        {
                            "itemCode":"8.5"
                        },
                        {
                            "itemCode":"8.6"
                        },
                        {
                            "itemCode":"8.7"
                        },
                        {
                            "itemCode":"8.8"
                        },
                        {
                            "itemCode":"8.9"
                        },
                        {
                            "itemCode":"8.10"
                        },
                        {
                            "itemCode":"8.11"
                        },
                        {
                            "itemCode":"8.12"
                        },
                        {
                            "itemCode":"8.13"
                        },
                        {
                            "itemCode":"8.14"
                        },
                        {
                            "itemCode":"8.15"
                        },
                        {
                            "itemCode":"8.16"
                        },
                        {
                            "itemCode":"8.17"
                        }
                    ]
                },
                {
                    "section":"09",
                    "items":[
                        {
                            "itemCode":"9.1"
                        },
                        {
                            "itemCode":"9.2"
                        },
                        {
                            "itemCode":"9.3"
                        },
                    ]
                }
            ]
        }
    }
];

export default assessmentDecisions;